import React from "react";
import SupplierCard from "./SupplierCard";
import "./SupplierCards.css";

const SupplierCards = ({ data, onCardClick }) => {
  return (
    <div className='suppliercards'>
      {data &&
        data
          .sort((a, b) => a.active - b.active)
          .map((supplier) => <SupplierCard supplier={supplier} onCardClick={onCardClick} />)}
    </div>
  );
};

export default SupplierCards;
